import React from 'react';

import CatalogLoader, { CatalogLoaderVariant } from '@components/controls/CatalogLoader';

import { Button } from '@scripts/gds';
import { useMedia } from '@scripts/hooks';
import { themeColor } from '@scripts/themes/cssVars';

import {
    getButtonStyles,
    getContainerStyles,
    getContentWrapperStyles,
    getDescriptionStyles,
    getTextContainerStyles,
    getTitleStyles,
} from './styles';

const EmptyProductsPlaceholder = ({ isLoading = false }: { isLoading?: boolean }) => {
    const { md, xs } = useMedia();

    return (
        <div css={getContainerStyles({ xs, md, isLoading })}>
            {isLoading ? (
                <CatalogLoader variant={CatalogLoaderVariant.Primary} background={themeColor.backgroundEmpty} />
            ) : (
                <div css={getContentWrapperStyles({ xs })}>
                    <div css={getTextContainerStyles({ xs })}>
                        <h2 css={getTitleStyles({ md, xs })}>Готовим обновление ассортимента</h2>
                        <p css={getDescriptionStyles({ md })}>Пока можете изучить другие наши категории</p>
                    </div>
                    <Button as="a" theme="secondary" href="/" css={getButtonStyles()}>
                        На главную
                    </Button>
                </div>
            )}
        </div>
    );
};

export default EmptyProductsPlaceholder;
